import React, { useRef, useState, useEffect } from 'react';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { Calendar } from 'primereact/calendar';
import { InputNumber } from 'primereact/inputnumber';
import { Button } from 'primereact/button';
import { FileUpload } from 'primereact/fileupload';
import { Divider } from 'primereact/divider';
import { Dialog } from 'primereact/dialog';
import { HEIGHT_UNITS } from './constants';
import { Card } from 'primereact/card';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { RadioButton } from 'primereact/radiobutton';
import { ProgressBar } from 'primereact/progressbar';
import { visualizarDocumento } from '../../services/empleado/empleadoDocumentoService';
import DotacionesLista from './DotacionesLista';
import VerArchivosGen from './VerArchivosGen';
import { BlockUI } from 'primereact/blockui';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';

// 2. RECIBIR unidadMedida Y handleUnitChange AQUÍ
export default function FormularioPrincipal({
    // 0. CONTROL DE VISIBILIDAD POR BLOQUE (permisos por pantalla)
    puedeVer = () => true,
    // 1. CORE / GENERAL DEL EMPLEADO
    formData,
    handleChange,
    isEditMode,
    goBack,
    listas,
    validationErrors,
    loading,
    toggleModal,
    handleAddConfig,

    // 2. ESTATURA Y UNIDADES
    unidadMedida,
    handleUnitChange,

    // 3. PENSIÓN ALIMENTICIA
    tienePensionDoc,
    savePensionDoc,
    deletePensionDoc,

    // 4. LICENCIAS DE CONDUCIR [cite: 1, 9]
    // 3. LICENCIAS (HOOK: useLicencia)
    licencias = [],
    licenciaLoading,
    openNewLicencia,
    openEditLicencia,
    deleteLicencia,
    onLicenciaChange,
    anulaLicencia,

    // 5. LIBRETAS MILITARES [cite: 5]
    libretas = [],
    openNewLibreta,
    openEditLibreta,
    deleteLibreta,
    anulaLibreta,

    // 6. UBICACIONES GPS (Múltiples) [cite: 3, 4, 5]
    ubicacionesList = [],
    openNewUbicacion,
    openEditUbicacion,
    deleteUbicacion,
    handleSetPrincipalUbicacion,
    ubicacionLoading,
    updatingPrincipalId,

    // 7. TELÉFONOS [cite: 10]
    phones = [],
    openNewPhone,
    openEditPhone,
    deletePhone,
    handleSetPrincipalPhone,

    // 8. EDUCACIÓN [cite: 10]
    educacionList = [],
    openNewEducacion,
    openEditEducacion,
    deleteEducacion,
    anulaEducacion,

    // 9. CUENTAS BANCARIAS [cite: 10]
    accounts = [],
    openNewAccount,
    openEditAccount,
    deleteAccount,
    handleSetPrincipalAccount,

    // 10. HISTORIAL / MEMOS [cite: 6, 7, 8]
    historialList = [],
    historialLoading,
    openNewHistorial,
    openEditHistorial,
    saveHistorial,
    deleteHistorial,
    setHistorialFile,
    anulaHistorial,

    // 11. FAMILIARES [cite: 11, 12]
    familiares = [],
    familiarLoading,
    familyDialog,
    setFamilyDialog,
    familiarData,
    setFamiliarData,
    openNewFamiliar,
    openEditFamiliar,
    saveFamiliar,
    deleteFamiliar,
    parentescoTemplate,

    // 12. OTROS DOCUMENTOS [cite: 10]
    otrosDocsList = [],
    openNewOtrosDocs,
    openEditOtrosDocs,
    deleteOtrosDocs,
    anulaOtrosDocs,

    // 13. FOTOS / GALERÍA [cite: 10]
    fotosList = [],
    openNewFoto,
    deleteFoto,
    openGallery,

    // 14. EXPERIENCIA
    openNewExperiencia,
    experiencias,
    experienciaLoading,
    openEditExperiencia,
    deleteExperiencia,

    //15. REPORTE
    generarReporteExpediente,
    reporteLoading,

    // otros datos
    datosPuesto, 
    resetCodigoUnico
}) {
    // Permisos por bloque aplicados a esta pantalla (Datos Empleados).
    const puedeEditarIdentificacion = puedeVer('BLOQUE_EDITAR_IDENTIFICACION');

    const textoLicencia = licencias.length > 0 ? 'Datos cargados...' : 'Sin datos';
    const estiloLicencia = licencias.length > 0 ? 'font-bold text-green-700' : 'surface-200';

    const textoLibreta = libretas.length > 0 ? 'Datos cargados...' : 'Sin datos';
    const estiloLibreta = libretas.length > 0 ? 'font-bold text-green-700' : 'surface-200';

    const areModulesDisabled = !isEditMode;
    const areIdsDisabled = isEditMode;
    const fileUploadRef = useRef(null);

    const [visorVisible, setVisorVisible] = useState(false);
    const [visorContent, setVisorContent] = useState(null);
    const [visorTitle, setVisorTitle] = useState('');

    const [visorType, setVisorType] = useState(null);

    const [mostrarArchivos, setMostrarArchivos] = useState(false);
    const [cabeceraData, setCabeceraData] = useState({});
    const [codigoVisible, setCodigoVisible] = useState(false);
    const [bloqueado, setBloqueado] = useState(false)

    const toggleVisibility = () => {
        setCodigoVisible(!codigoVisible);
    };

    // CODIGO AUMENTADO
    const [filtrosLicencia, setFiltrosLicencia] = useState({
        global: { value: null, matchMode: 'contains' },
        numero: { value: null, matchMode: 'contains' },
        categoria: { value: null, matchMode: 'contains' }
    });

    const [valoresFiltrosLicencia, setValoresFiltrosLicencia] = useState({
        numero: '',
        categoria: '',
        global: ''
    });
    const textoFilterTemplateLicencia = (options, field) => {
        return (
            <InputText
                value={valoresFiltrosLicencia[field]}
                onChange={(e) => {
                    const nuevoValor = e.target.value;
                    // Actualizamos el valor visual
                    setValoresFiltrosLicencia((prev) => ({ ...prev, [field]: nuevoValor }));

                    // Actualizamos el filtro real después de un pequeño delay
                    setTimeout(() => {
                        const newFilters = { ...filtrosLicencia };
                        newFilters[field].value = nuevoValor;
                        setFiltrosLicencia(newFilters);
                        options.filterApplyCallback(nuevoValor);
                    }, 10);
                }}
                placeholder={`Filtrar por ${field}`}
                className="w-full"
            />
        );
    };

    const verArchivosTable = (datosCab) => {
        setCabeceraData(datosCab);
        setMostrarArchivos(true);
    };
    const verArchivosTemplate = (rowData) => {
        return (
            <Button
                icon="pi pi-eye"
                className="p-button-rounded p-button-text p-button-info"
                tooltip="Ver Archivos"
                onClick={() => verArchivosTable(rowData)}
            />
        );
    };

    // convirtiendo la lista de licencias en licenciasFil
    //console.log('----- LICENCIAS: ', licencias);
    const licenciasFil = licencias.map((item) => ({
        id: item.id,
        categoria: listas.categoriasLicencia.find((c) => c.configuracionDetId === item.categoria)?.nombre ?? '',
        //categoria: 'licencia',
        numero: item.numero,
        fechaEmision: item.fechaEmision,
        fechaVencimiento: item.fechaVencimiento,
        archivoUrl: item.archivoUrl,
        categoriaId: item.categoria
    }));

    // PARA LIBRETAS
    const [filtrosLibreta, setFiltrosLibreta] = useState({
        global: { value: null, matchMode: 'contains' },
        numero: { value: null, matchMode: 'contains' },
        categoria: { value: null, matchMode: 'contains' }
    });

    const [valoresFiltrosLibreta, setValoresFiltrosLibreta] = useState({
        numero: '',
        categoria: '',
        global: ''
    });
    const textoFilterTemplateLibreta = (options, field) => {
        return (
            <InputText
                value={valoresFiltrosLibreta[field]}
                onChange={(e) => {
                    const nuevoValor = e.target.value;
                    // Actualizamos el valor visual
                    setValoresFiltrosLibreta((prev) => ({ ...prev, [field]: nuevoValor }));

                    // Actualizamos el filtro real después de un pequeño delay
                    setTimeout(() => {
                        const newFilters = { ...filtrosLibreta };
                        newFilters[field].value = nuevoValor;
                        setFiltrosLibreta(newFilters);
                        options.filterApplyCallback(nuevoValor);
                    }, 10);
                }}
                placeholder={`Filtrar por ${field}`}
                className="w-full"
            />
        );
    };

    const libretasFil = libretas.map((item) => ({
        id: item.id,
        categoria: listas.categoriasLibreta.find((c) => c.configuracionDetId === item.categoria)?.nombre ?? '',
        numero: item.numero,
        fechaIngreso: item.fechaIngreso,
        fechaFin: item.fechaFin,
        archivoUrl: item.archivoUrl,
        categoriaId: item.categoria
    }));

    // PARA UBICACIONES
    const [filtrosUbicacion, setFiltrosUbicacion] = useState({
        global: { value: null, matchMode: 'contains' },
        nombre: { value: null, matchMode: 'contains' },
        descripcion: { value: null, matchMode: 'contains' }
    });

    const [valoresFiltrosUbicacion, setValoresFiltrosUbicacion] = useState({
        nombre: '',
        descripcion: '',
        global: ''
    });
    const textoFilterTemplateUbicacion = (options, field) => {
        return (
            <InputText
                value={valoresFiltrosUbicacion[field]}
                onChange={(e) => {
                    const nuevoValor = e.target.value;
                    // Actualizamos el valor visual
                    setValoresFiltrosUbicacion((prev) => ({ ...prev, [field]: nuevoValor }));

                    // Actualizamos el filtro real después de un pequeño delay
                    setTimeout(() => {
                        const newFilters = { ...filtrosUbicacion };
                        newFilters[field].value = nuevoValor;
                        setFiltrosUbicacion(newFilters);
                        options.filterApplyCallback(nuevoValor);
                    }, 10);
                }}
                placeholder={`Filtrar por ${field}`}
                className="w-full"
            />
        );
    };

    // para PHONES
    const phonesFil = phones.map((item) => ({
        id: item.id,
        numero: item.numero,
        referencia: item.referencia,
        principal: item.principal,
        tipo: listas.tiposTelefono.find((x) => x.configuracionDetId === item.tipo)?.nombre ?? '',
        tipoId: item.tipo
    }));

    const [filtrosPhones, setFiltrosPhones] = useState({
        global: { value: null, matchMode: 'contains' },
        tipo: { value: null, matchMode: 'contains' },
        numero: { value: null, matchMode: 'contains' },
        referencia: { value: null, matchMode: 'contains' }
    });

    const [valoresFiltrosPhones, setValoresFiltrosPhones] = useState({
        tipo: '',
        numero: '',
        referencia: '',
        global: ''
    });
    const textoFilterTemplatePhones = (options, field) => {
        return (
            <InputText
                value={valoresFiltrosPhones[field]}
                onChange={(e) => {
                    const nuevoValor = e.target.value;
                    // Actualizamos el valor visual
                    setValoresFiltrosPhones((prev) => ({ ...prev, [field]: nuevoValor }));

                    // Actualizamos el filtro real después de un pequeño delay
                    setTimeout(() => {
                        const newFilters = { ...filtrosPhones };
                        newFilters[field].value = nuevoValor;
                        setFiltrosPhones(newFilters);
                        options.filterApplyCallback(nuevoValor);
                    }, 10);
                }}
                placeholder={`Filtrar por ${field}`}
                className="w-full"
            />
        );
    };

    // para EDUCACION
    const educacionListFil = educacionList.map((item) => ({
        id: item.id,
        categoria: listas.nivelesEducacion.find((c) => c.configuracionDetId === item.categoria)?.nombre ?? '',
        institucion: item.institucion,
        titulo_nombre: item.titulo_nombre,
        fechaInicio: item.fechaInicio,
        fechaFin: item.fechaFin,
        archivoUrl: item.archivoUrl,
        categoriaId: item.categoria
    }));

    const [filtrosEducacion, setFiltrosEducacion] = useState({
        global: { value: null, matchMode: 'contains' },
        categoria: { value: null, matchMode: 'contains' },
        institucion: { value: null, matchMode: 'contains' },
        titulo_nombre: { value: null, matchMode: 'contains' }
    });

    const [valoresFiltrosEducacion, setValoresFiltrosEducacion] = useState({
        categoria: '',
        institucion: '',
        titulo_nombre: '',
        global: ''
    });
    const textoFilterTemplateEducacion = (options, field) => {
        return (
            <InputText
                value={valoresFiltrosEducacion[field]}
                onChange={(e) => {
                    const nuevoValor = e.target.value;
                    console.log('value:', field);
                    // Actualizamos el valor visual
                    setValoresFiltrosEducacion((prev) => ({ ...prev, [field]: nuevoValor }));

                    // Actualizamos el filtro real después de un pequeño delay
                    setTimeout(() => {
                        const newFilters = { ...filtrosEducacion };
                        newFilters[field].value = nuevoValor;
                        setFiltrosEducacion(newFilters);
                        options.filterApplyCallback(nuevoValor);
                    }, 10);
                }}
                placeholder={`Filtrar por ${field}`}
                className="w-full"
            />
        );
    };
    // para CUENTAS BANCARIAS
    const accountsFil = accounts.map((item) => {
        // 1. Buscamos los objetos correspondientes usando el ID correcto (bancoId)
        const bancoEncontrado = listas.bancos.find((x) => x.configuracionDetId === item.bancoId);
        const tipoEncontrado = listas.tiposCuenta.find((x) => x.configuracionDetId === item.tipoCuentaId);
    
        return {
            id: item.id,
            numeroCuenta: item.numeroCuenta,
            // 2. Usamos encadenamiento opcional (?.) para evitar que el PDF/App se rompa si no hay match
            banco: bancoEncontrado ? bancoEncontrado.nombre : 'Banco no definido',
            tipoCuenta: tipoEncontrado ? tipoEncontrado.nombre : 'Tipo no definido',
            esPrincipal: item.esPrincipal,
            // 3. Mantenemos los IDs para que los diálogos de edición funcionen
            tipoCuentaId: item.tipoCuentaId,
            bancoId: item.bancoId
        };
    });

    const [filtrosBancos, setFiltrosBancos] = useState({
        global: { value: null, matchMode: 'contains' },
        banco: { value: null, matchMode: 'contains' },
        numeroCuenta: { value: null, matchMode: 'contains' },
        tipoCuenta: { value: null, matchMode: 'contains' }
    });

    const [valoresFiltrosBancos, setValoresFiltrosBancos] = useState({
        banco: '',
        numeroCuenta: '',
        tipoCuenta: '',
        global: ''
    });
    const textoFilterTemplateBancos = (options, field) => {
        return (
            <InputText
                value={valoresFiltrosBancos[field]}
                onChange={(e) => {
                    const nuevoValor = e.target.value;
                    setValoresFiltrosBancos((prev) => ({ ...prev, [field]: nuevoValor }));

                    setTimeout(() => {
                        const newFilters = { ...filtrosBancos };
                        newFilters[field].value = nuevoValor;
                        setFiltrosBancos(newFilters);
                        options.filterApplyCallback(nuevoValor);
                    }, 10);
                }}
                placeholder={`Filtrar por ${field}`}
                className="w-full"
            />
        );
    };

    // para HISTORIAL
    const historialListFil = historialList.map((item) => ({
        id: item.id,
        numero: item.numero,
        observaciones: item.observaciones,
        tipo: listas.tiposHistorial.find((c) => c.configuracionDetId === item.tipo)?.nombre ?? '',
        fechaEmision: item.fechaEmision,
        fecha_fin: item.fecha_fin,
        fecha_inicio: item.fecha_Inicio,
        archivoUrl: item.archivoUrl,
        tipoId: item.tipo
    }));

    const [filtrosHistorial, setFiltrosHistorial] = useState({
        global: { value: null, matchMode: 'contains' },
        tipo: { value: null, matchMode: 'contains' },
        numero: { value: null, matchMode: 'contains' },
        observaciones: { value: null, matchMode: 'contains' }
    });

    const [valoresFiltrosHistorial, setValoresFiltrosHistorial] = useState({
        tipo: '',
        numero: '',
        observaciones: '',
        global: ''
    });
    const textoFilterTemplateHistorial = (options, field) => {
        return (
            <InputText
                value={valoresFiltrosHistorial[field]}
                onChange={(e) => {
                    const nuevoValor = e.target.value;
                    setValoresFiltrosHistorial((prev) => ({ ...prev, [field]: nuevoValor }));

                    setTimeout(() => {
                        const newFilters = { ...filtrosHistorial };
                        newFilters[field].value = nuevoValor;
                        setFiltrosHistorial(newFilters);
                        options.filterApplyCallback(nuevoValor);
                    }, 10);
                }}
                placeholder={`Filtrar por ${field}`}
                className="w-full"
            />
        );
    };

    // para FAMILIARES
    const familiaresFil = familiares.map((item) => ({
        id: item.id,
        nombre: item.nombre,
        identificador: item.identificador,
        tipoFamiliar: item.tipoFamiliar || 'N/A',
        parentesco: item.parentesco || 'N/A',
        esCargaFamiliar: item.esCargaFamiliar,
        fechaNacimiento: item.fechaNacimiento,
        aplicaUtilidad: item.aplicaUtilidad,
        tipoIdentificadorConfId: item.tipoIdentificadorConfId,
        tipoFamiliarConfId: item.tipoFamiliarConfId,
        parentescoConfId: item.parentescoConfId,
        parentescoId: item.parentescoConfId,
        tipoDoc: item.tipoIdentificadorConfId,
        tipoFamiliarId: item.tipoFamiliarConfId
    }));

    const [filtrosFamilia, setFiltrosFamilia] = useState({
        global: { value: null, matchMode: 'contains' },
        identificador: { value: null, matchMode: 'contains' },
        nombre: { value: null, matchMode: 'contains' },
        parentesco: { value: null, matchMode: 'contains' },
        tipoFamiliar: { value: null, matchMode: 'contains' }
    });

    const [valoresFiltrosFamilia, setValoresFiltrosFamilia] = useState({
        identificador: '',
        nombre: '',
        parentesco: '',
        tipoFamiliar: '',
        global: ''
    });
    const textoFilterTemplateFamilia = (options, field) => {
        return (
            <InputText
                value={valoresFiltrosFamilia[field]}
                onChange={(e) => {
                    const nuevoValor = e.target.value;
                    setValoresFiltrosFamilia((prev) => ({ ...prev, [field]: nuevoValor }));

                    setTimeout(() => {
                        const newFilters = { ...filtrosFamilia };
                        newFilters[field].value = nuevoValor;
                        setFiltrosFamilia(newFilters);
                        options.filterApplyCallback(nuevoValor);
                    }, 10);
                }}
                placeholder={`Filtrar por ${field}`}
                className="w-full"
            />
        );
    };

    // para OTROS DOCUMENTOS otrosDocsList
    const otrosDocsListFil = otrosDocsList.map((item) => ({
        id: item.id,
        categoria_id: listas.tiposOtrosDocs.find((c) => c.configuracionDetId === item.categoria_id)?.nombre ?? '',
        numero: item.numero,
        descripcion: item.descripcion,
        fecha_fin: item.fecha_fin,
        fecha_inicio: item.fecha_inicio,
        archivoUrl: item.archivoUrl,
        categoriaId: item.categoria_id
    }));

    const [filtrosOtrosDocs, setFiltrosOtrosDocs] = useState({
        global: { value: null, matchMode: 'contains' },
        numero: { value: null, matchMode: 'contains' },
        categoria_id: { value: null, matchMode: 'contains' },
        descripcion: { value: null, matchMode: 'contains' }
    });

    const [valoresFiltrosOtrosDocs, setValoresFiltrosOtrosDocs] = useState({
        numero: '',
        categoria_id: '',
        descripcion: '',
        global: ''
    });
    const textoFilterTemplateOtrosDocs = (options, field) => {
        return (
            <InputText
                value={valoresFiltrosOtrosDocs[field]}
                onChange={(e) => {
                    const nuevoValor = e.target.value;
                    setValoresFiltrosOtrosDocs((prev) => ({ ...prev, [field]: nuevoValor }));

                    setTimeout(() => {
                        const newFilters = { ...filtrosOtrosDocs };
                        newFilters[field].value = nuevoValor;
                        setFiltrosOtrosDocs(newFilters);
                        options.filterApplyCallback(nuevoValor);
                    }, 10);
                }}
                placeholder={`Filtrar por ${field}`}
                className="w-full"
            />
        );
    };

    // para FOTOS
    const [filtrosFotos, setFiltrosFotos] = useState({
        global: { value: null, matchMode: 'contains' },
        descripcion: { value: null, matchMode: 'contains' }
    });

    const [valoresFiltrosFotos, setValoresFiltrosFotos] = useState({
        descripcion: '',
        global: ''
    });
    const textoFilterTemplateFotos = (options, field) => {
        return (
            <InputText
                value={valoresFiltrosFotos[field]}
                onChange={(e) => {
                    const nuevoValor = e.target.value;
                    setValoresFiltrosFotos((prev) => ({ ...prev, [field]: nuevoValor }));

                    setTimeout(() => {
                        const newFilters = { ...filtrosFotos };
                        newFilters[field].value = nuevoValor;
                        setFiltrosFotos(newFilters);
                        options.filterApplyCallback(nuevoValor);
                    }, 10);
                }}
                placeholder={`Filtrar por ${field}`}
                className="w-full"
            />
        );
    };

    // para EXPERIENCIA LABORAL
    const [filtrosExperiencia, setFiltrosExperiencia] = useState({
        global: { value: null, matchMode: 'contains' },
        empresa: { value: null, matchMode: 'contains' },
        motivoSalida: { value: null, matchMode: 'contains' },
        proyecto: { value: null, matchMode: 'contains' }
    });

    const [valoresFiltrosExperiencia, setValoresExperiencia] = useState({
        empresa: '',
        motivoSalida: '',
        proyecto: '',
        global: ''
    });
    const textoFilterTemplateExperiencia = (options, field) => {
        return (
            <InputText
                value={valoresFiltrosExperiencia[field]}
                onChange={(e) => {
                    const nuevoValor = e.target.value;
                    setValoresExperiencia((prev) => ({ ...prev, [field]: nuevoValor }));

                    setTimeout(() => {
                        const newFilters = { ...filtrosExperiencia };
                        newFilters[field].value = nuevoValor;
                        setFiltrosExperiencia(newFilters);
                        options.filterApplyCallback(nuevoValor);
                    }, 10);
                }}
                placeholder={`Filtrar por ${field}`}
                className="w-full"
            />
        );
    };
    // CODIGO AUMENTADO

    // --- TEMPLATES REUTILIZABLES PARA LAS TABLAS ---
    const headerTable = (label, icon, onClick) => (
        <div className="flex justify-content-between align-items-center mb-2">
            <span className="text-900 font-bold flex align-items-center">
                <i className={`${icon} mr-2 text-primary`} style={{ fontSize: '1.2rem' }}></i>
                {label}
            </span>
            <Button
                label="Nuevo"
                icon="pi pi-plus"
                className=" p-button-success p-button-sm w-auto shadow-2"
                onClick={onClick}
                disabled={areModulesDisabled}
                tooltip="Agregar Nuevo"
                tooltipOptions={{ position: 'top' }}
            />
        </div>
    );

    const dateTemplate = (rowData, field) => {
        if (!rowData[field]) return '';
        return new Date(rowData[field]).toLocaleDateString();
    };

    if (!formData) {
        return (
            <div className="flex align-items-center justify-content-center p-5">
                <i className="pi pi-spin pi-spinner text-4xl mr-2"></i>
                <span>Cargando formulario...</span>
            </div>
        );
    }

    const FotoThumbnail = ({ id, descripcion }) => {
        const [imageSrc, setImageSrc] = useState(null);
        const [loading, setLoading] = useState(true);

        useEffect(() => {
            let objectUrl = null;
            const cargarImagen = async () => {
                try {
                    // Usamos el MISMO servicio que usas para el botón "Ver"
                    // Esto descarga los bits de la imagen de forma segura
                    const blob = await visualizarDocumento(id);
                    if (blob) {
                        objectUrl = URL.createObjectURL(blob);
                        setImageSrc(objectUrl);
                    }
                } catch (error) {
                    console.error('Error cargando thumb:', error);
                } finally {
                    setLoading(false);
                }
            };

            if (id) cargarImagen();

            // Limpieza de memoria cuando el componente se desmonta
            return () => {
                if (objectUrl) URL.revokeObjectURL(objectUrl);
            };
        }, [id]);

        // Renderizado condicional
        if (loading)
            return <i className="pi pi-spin pi-spinner" style={{ fontSize: '1.5rem' }}></i>;
        if (!imageSrc) return <i className="pi pi-image text-400" style={{ fontSize: '2rem' }}></i>;

        return (
            <img
                src={imageSrc}
                alt={descripcion}
                className="shadow-2 border-round cursor-pointer"
                style={{ width: '60px', height: '60px', objectFit: 'cover' }}
                // Opcional: Si haces click, se abre en grande usando la URL que ya generamos
                onClick={() => window.open(imageSrc, '_blank')}
            />
        );
    };

    const categoriaBodyTemplate = (rowData) => {
        // Buscamos el ID en la lista de categoriasLicencia que ya tienes cargada
        const cat = listas.categoriasLicencia.find(
            (c) => c.configuracionDetId === rowData.categoria
        );
        return cat ? cat.nombre : 'Cargando...';
    };

    const archivoBodyTemplate = (rowData) => {
        if (!rowData.id) return null;

        // Función expandida para detectar archivos que el navegador puede "abrir"
        const esVisualizable = () => {
            const nombre = (rowData.archivoUrl || rowData.nombreArchivo || '').toLowerCase();
            // Incluimos imágenes y PDFs
            return /\.(jpeg|jpg|gif|png|webp|bmp|pdf)$/i.test(nombre);
        };

        return (
            <div className="flex gap-2 justify-content-center">
                {/* Ahora el botón "Ver" aparece para Imágenes Y para PDFs */}
                {esVisualizable() && (
                    <Button
                        icon="pi pi-eye"
                        className="p-button-rounded p-button-text p-button-info"
                        tooltip="Visualizar"
                        onClick={() => handleVerDocumento(rowData)}
                    />
                )}

                <Button
                    icon="pi pi-download"
                    className="p-button-rounded p-button-text p-button-success"
                    tooltip="Descargar"
                    onClick={() => handleDescargarDocumento(rowData)}
                />
            </div>
        );
    };

    const handleVerDocumento = async (rowData) => {
        try {
            // 1. Obtenemos el archivo
            const blob = await visualizarDocumento(rowData.id);
            if (!blob) {
                alert('El archivo no tiene contenido.');
                return;
            }

            // 2. Detectamos tipo y nombre
            let tipoArchivo = blob.type;
            const nombreOriginal = (
                rowData.nombreArchivo ||
                rowData.archivoUrl ||
                ''
            ).toLowerCase();

            // Corrección de tipos si el backend manda genérico
            if (!tipoArchivo || tipoArchivo === 'application/octet-stream') {
                if (nombreOriginal.endsWith('.pdf')) tipoArchivo = 'application/pdf';
                else if (nombreOriginal.match(/\.(jpg|jpeg|png|gif|webp)$/))
                    tipoArchivo = 'image/jpeg';
                else if (nombreOriginal.includes('.doc')) tipoArchivo = 'application/msword';
                else if (nombreOriginal.includes('.xls')) tipoArchivo = 'application/vnd.ms-excel';
            }

            const fileURL = URL.createObjectURL(blob);

            // --- CASO 1: IMÁGENES (Modal) ---
            if (tipoArchivo && tipoArchivo.startsWith('image/')) {
                setVisorContent(fileURL);
                setVisorType(tipoArchivo);
                setVisorTitle(rowData.descripcion || rowData.nombreArchivo || 'Visualización');
                setVisorVisible(true);
            }

            // --- CASO 2: PDF (Pestaña Nueva) ---
            else if (tipoArchivo === 'application/pdf') {
                // Intentamos abrir pestaña nueva
                const pdfWindow = window.open(fileURL, '_blank');

                // Si el navegador bloquea la pestaña o está configurado para descargar todo,
                // NO podemos cambiar el nombre del UUID aquí lamentablemente (limitación del navegador).
                // Pero si el usuario tiene configurado "Abrir PDFs", se verá bien.
                if (!pdfWindow) {
                    alert('Por favor habilite las ventanas emergentes para ver el PDF.');
                }
            }

            // --- CASO 3: OFFICE Y OTROS (Descarga con Nombre Correcto) ---
            else {
                // Aquí es donde arreglamos el problema del UUID para Words/Excel
                const link = document.createElement('a');
                link.href = fileURL;

                // Calculamos el nombre correcto
                let nombreFinal = rowData.nombreArchivo || `documento_${rowData.id}`;

                // Si falta la extensión, se la pegamos
                if (nombreFinal.indexOf('.') === -1) {
                    if (tipoArchivo.includes('word') || tipoArchivo.includes('officedocument'))
                        nombreFinal += '.docx';
                    else if (tipoArchivo.includes('sheet') || tipoArchivo.includes('excel'))
                        nombreFinal += '.xlsx';
                    else if (tipoArchivo.includes('pdf')) nombreFinal += '.pdf';
                    else nombreFinal += '.dat';
                }

                // ESTA LÍNEA ES LA QUE EVITA EL UUID:
                link.download = nombreFinal;

                link.click();
            }
        } catch (error) {
            console.error('Error visualizando documento:', error);
            alert('No se pudo cargar el documento.');
        }
    };

    const handleDescargarDocumento = async (rowData) => {
        try {
            // 1. Obtenemos el archivo (Blob)
            const blob = await visualizarDocumento(rowData.id);
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;

            // 2. Determinamos la extensión
            let extension = '';

            // A) Intentamos sacarla de la URL original si existe (ej: "foto.jpg")
            if (rowData.archivoUrl) {
                const partes = rowData.archivoUrl.split('.');
                if (partes.length > 1) {
                    extension = partes.pop().toLowerCase();
                    // Limpieza básica por si la URL tiene parámetros extra
                    if (extension.length > 4) extension = '';
                }
            }

            // B) Si no hay extensión en la URL, la sacamos del tipo de archivo (MIME Type)
            if (!extension) {
                if (blob.type === 'application/pdf') extension = 'pdf';
                else if (blob.type === 'image/jpeg') extension = 'jpg';
                else if (blob.type === 'image/png') extension = 'png';
                else if (blob.type.includes('word')) extension = 'docx';
                else if (blob.type.includes('sheet') || blob.type.includes('excel'))
                    extension = 'xlsx';
                else extension = 'dat'; // Binario genérico
            }

            // 3. Armamos el nombre final
            // Usamos 'nombreArchivo' si viene del backend, o generamos uno genérico con la extensión detectada
            let nombreFinal = rowData.nombreArchivo || `documento_${rowData.id}`;

            // Si el nombre no tiene punto, le pegamos la extensión que encontramos
            if (nombreFinal.indexOf('.') === -1 && extension) {
                nombreFinal = `${nombreFinal}.${extension}`;
            }

            link.setAttribute('download', nombreFinal);

            // 4. Descarga
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error('Error al descargar:', error);
            // Puedes usar toast si lo prefieres: toast.current.show(...)
            alert('No se pudo descargar el archivo.');
        }
    };

    const tipoTelefonoTemplate = (rowData) => {
        const t = listas.tiposTelefono.find((x) => x.configuracionDetId === rowData.tipo);
        return t ? t.nombre : '...';
    };

    const principalPhoneTemplate = (rowData) => {
        return (
            <div className="flex justify-content-center">
                <RadioButton
                    // 'principal' es el nombre del campo que mapeamos en goToEdit
                    checked={rowData.principal === true}
                    onChange={() => handleSetPrincipalPhone(rowData)}
                    name="radioTelefonoPrincipal"
                    aria-label="Marcar como principal"
                />
            </div>
        );
    };

    if (loading) {
        return (
            <div
                className="flex flex-column align-items-center justify-content-center p-6 surface-card border-round shadow-2"
                style={{ minHeight: '400px' }}
            >
                <i className="pi pi-spin pi-spinner text-primary text-6xl mb-4"></i>
                <span className="text-xl text-700 font-medium">
                    Cargando expediente completo...
                </span>
                <div className="w-16rem mt-3">
                    <ProgressBar mode="indeterminate" style={{ height: '6px' }} />
                </div>
            </div>
        );
    }

    const handleVerPension = async () => {
        if (!formData.pensionDocId) return;

        try {
            // 1. Traer el archivo
            const blob = await visualizarDocumento(formData.pensionDocId);

            // 2. Detectar Tipo (Igual que hicimos en DialogosEmpleado)
            let tipoArchivo = blob.type;

            // Corrección basada en el nombre (si el backend falla)
            let extension = '';
            if (formData.urlPension) {
                const partes = formData.urlPension.split('.');
                if (partes.length > 1) extension = partes.pop().toLowerCase();
            }

            if (!tipoArchivo || tipoArchivo === 'application/octet-stream') {
                if (extension === 'pdf') tipoArchivo = 'application/pdf';
                else if (['jpg', 'jpeg', 'png', 'gif'].includes(extension))
                    tipoArchivo = 'image/jpeg';
            }

            const fileURL = URL.createObjectURL(blob);

            // 3. DECIDIR CÓMO MOSTRARLO

            // CASO 1: IMAGEN -> Abrir Modal Local
            if (tipoArchivo && tipoArchivo.startsWith('image/')) {
                setVisorContent(fileURL);
                setVisorType(tipoArchivo);
                setVisorVisible(true);
            }
            // CASO 2: PDF -> Pestaña Nueva
            else if (tipoArchivo === 'application/pdf') {
                const pdfWindow = window.open(fileURL, '_blank');
                if (!pdfWindow) alert('Habilite ventanas emergentes para ver el PDF.');
            }
            // CASO 3: OTROS -> Descargar (Usamos tu lógica de descarga existente)
            else {
                handleDescargarPension();
            }
        } catch (error) {
            console.error('Error al visualizar:', error);
            alert('No se pudo cargar el documento.');
        }
    };

    const handleDescargarPension = async () => {
        if (!formData.pensionDocId) return;

        try {
            const blob = await visualizarDocumento(formData.pensionDocId);
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;

            // --- LÓGICA MEJORADA ---

            // 1. Intentamos sacar la extensión REAL del nombre de archivo original (urlPension)
            let extensionFinal = '';

            if (formData.urlPension) {
                // Ejemplo url: "http://.../FichaFutbol.pdf" -> split -> ["FichaFutbol", "pdf"]
                const partes = formData.urlPension.split('.');
                if (partes.length > 1) {
                    extensionFinal = partes.pop().toLowerCase(); // "pdf"
                }
            }

            // 2. Si falló lo anterior (ej: no hay urlPension), usamos el MIME type del blob como respaldo
            if (!extensionFinal) {
                if (blob.type === 'application/pdf') extensionFinal = 'pdf';
                else if (blob.type === 'image/jpeg') extensionFinal = 'jpg';
                else if (blob.type === 'image/png') extensionFinal = 'png';
                else if (blob.type.includes('word')) extensionFinal = 'docx';
                else if (blob.type.includes('sheet') || blob.type.includes('excel'))
                    extensionFinal = 'xlsx';
                else extensionFinal = 'dat'; // Default seguro (mejor que png para no corromper)
            }

            // 3. Armamos el nombre
            // Si detectamos que era un PDF, se bajará como "pension_12345.pdf"
            const nombreArchivo = `pension_${formData.nroIdentificador || 'doc'}.${extensionFinal}`;

            link.setAttribute('download', nombreArchivo);

            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error('Error al descargar:', error);
            alert('Error al descargar el archivo.');
        }
    };

    const tableProps = {
        paginator: true,
        rows: 5,
        rowsPerPageOptions: [5, 10, 20],
        className: 'datatable-responsive',
        paginatorTemplate:
            'FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown',
        currentPageReportTemplate: '{first} a {last} de {totalRecords}',
        size: 'small',
        showGridlines: true
    };

    //console.log('MIS DATOS...: ', datosPuesto);
    const resetCodigo = async () => {
        setBloqueado(true)
        try {
            const data = await resetCodigoUnico(formData)
        } catch (error) {
            console.err ('ERROR: no se pudo Resetear Codigo')
        } finally {
            setBloqueado(false)
        }
    }
    const cancelaReset = () => {
        if (bloqueado) {
            setBloqueado(false)
        }
    }

    const confirmaReset = () => {
        confirmDialog({
            message: 'Confirma Resetear el Código Único?',
            header: 'Reset Confirmación',
            icon: 'pi pi-info-circle',
            accept: resetCodigo,
            reject: cancelaReset
        });
    }

    return (
        <div className="p-fluid formgrid grid">
            <ConfirmDialog />
            <BlockUI blocked={bloqueado} fullScreen />
            <div className="col-12 mb-3 flex justify-content-between align-items-center">
                <Button
                    label="Volver a la lista"
                    icon="pi pi-arrow-left"
                    className="p-button-text p-button-secondary w-auto"
                    onClick={goBack}
                />
            </div>

            {/* SECCIÓN 1: IDENTIFICACIÓN - DISEÑO GENERAL OPTIMIZADO */}
            <div className="col-12">
                <Divider align="left">
                    <div className="inline-flex align-items-center">
                        <i className="pi pi-id-card mr-2"></i>
                        <b className="text-900">Identificación</b>
                    </div>
                </Divider>
            </div>

            {/* FILA 1: DOCUMENTO Y NÚMERO (Proporción 4-8 para balance visual) */}
            <div className="field col-12 md:col-4">
                <label htmlFor="tipoDoc" className="block mb-2 font-bold text-700 text-sm">
                    Tipo Doc.
                </label>
                <div className="p-inputgroup">
                    <Dropdown
                        id="tipoDoc"
                        value={formData.tipoDoc}
                        options={listas.tiposDocumento}
                        onChange={(e) => handleChange('tipoDoc', e.value)}
                        optionLabel="nombre"
                        optionValue="configuracionDetId"
                        placeholder="Seleccione"
                        disabled={areIdsDisabled || !puedeEditarIdentificacion}
                        className="w-full"
                    />
                    <Button
                        type="button"
                        icon="pi pi-plus"
                        className="p-button-success"
                        onClick={() => handleAddConfig('TIPO_DOCUMENTO')}
                        disabled={areIdsDisabled || !puedeEditarIdentificacion}
                        tooltip="Nuevo Tipo de Doc"
                    />
                </div>
            </div>

            <div className="field col-12 md:col-8">
                <label htmlFor="nroIdentificador" className="block mb-2 font-bold text-700 text-sm">
                    Nro Identificador
                </label>
                <InputText
                    id="nroIdentificador"
                    value={formData.nroIdentificador}
                    onChange={(e) => handleChange('nroIdentificador', e.target.value)}
                    className={`w-full ${areIdsDisabled ? 'opacity-60' : 'font-bold'} ${
                        validationErrors.nroIdentificador ? 'p-invalid' : ''
                    }`}
                    disabled={areIdsDisabled || !puedeEditarIdentificacion}
                    placeholder="Ingrese número de documento"
                />
                {validationErrors.nroIdentificador && (
                    <small className="p-error">{validationErrors.nroIdentificador}</small>
                )}
            </div>

            {/* FILA 2: NOMBRE Y APELLIDOS (Ítem 2: Misma línea, proporción 50/50) */}
            <div className="field col-12 md:col-6">
                <label htmlFor="nombre" className="block mb-2 font-bold text-700 text-sm">
                    Nombre
                </label>
                <InputText
                    id="nombre"
                    value={formData.nombre}
                    onChange={(e) => handleChange('nombre', e.target.value)}
                    className={`w-full ${validationErrors.nombre ? 'p-invalid' : ''}`}
                    placeholder="Ej: Juan Pérez"
                    disabled={!puedeEditarIdentificacion}
                />
                {validationErrors.nombre && (
                    <small className="p-error">{validationErrors.nombre}</small>
                )}
            </div>

            <div className="field col-12 md:col-6">
                <label htmlFor="apellido" className="block mb-2 font-bold text-700 text-sm">
                    Apellidos
                </label>
                <InputText
                    id="apellido"
                    value={formData.apellido}
                    onChange={(e) => handleChange('apellido', e.target.value)}
                    className={`w-full ${validationErrors.apellido ? 'p-invalid' : ''}`}
                    placeholder="Ej: Ramos García"
                    disabled={!puedeEditarIdentificacion}
                />
                {validationErrors.apellido && (
                    <small className="p-error">{validationErrors.apellido}</small>
                )}
            </div>
            {/** datos puesto */}
            <div className="col-12">
                <Divider align="left">
                    <div className="inline-flex align-items-center">
                        <i className="pi pi-id-card mr-2"></i>
                        <b className="text-900">Datos Puesto</b>
                    </div>
                </Divider>
            </div>
            <div className="field col-12 md:col-4">
                <label htmlFor="nroIdentificador" className="block mb-2 font-bold text-700 text-sm">
                    Cliente
                </label>
                <InputText
                    className={`w-full opacity-60 font-bold`}
                    value={datosPuesto?.clienteNombre}
                    disabled
                />
            </div>
            <div className="field col-12 md:col-4">
                <label htmlFor="nroIdentificador" className="block mb-2 font-bold text-700 text-sm">
                    Proyecto
                </label>
                <InputText
                    className={`w-full opacity-60 font-bold`}
                    value={datosPuesto?.proyectoNombre}
                    disabled
                />
            </div>
            <div className="field col-12 md:col-4">
                <label htmlFor="nroIdentificador" className="block mb-2 font-bold text-700 text-sm">
                    Puesto
                </label>
                <InputText
                    className={`w-full opacity-60 font-bold`}
                    value={datosPuesto?.puestoNombre}
                    disabled
                />
            </div>

            {puedeVer('BLOQUE_DATOS_PERSONALES') && (<>
            {/* SECCIÓN 2: DATOS PERSONALES */}
            <div className="col-12">
                <Divider align="left">
                    <div className="inline-flex align-items-center">
                        <i className="pi pi-user mr-2"></i>
                        <b>Datos Personales</b>
                    </div>
                </Divider>
            </div>

            <div className="field col-12 md:col-4">
                <label>Nacionalidad</label>

                <div className="p-inputgroup">
                    <Dropdown
                        value={formData.nacionalidad}
                        options={listas.paises}
                        onChange={(e) => handleChange('nacionalidad', e.value)}
                        optionValue="configuracionDetId"
                        optionLabel="nombre"
                        filter
                    />
                    <Button
                        icon="pi pi-plus"
                        className="p-button-success"
                        onClick={() => handleAddConfig('PAISES')}
                        type="button"
                    />
                </div>
            </div>
            <div className="field col-12 md:col-4">
                <label>Lugar Nacimiento</label>
                <div className="p-inputgroup">
                    <Dropdown
                        value={formData.lugarNacimiento}
                        options={listas.paises}
                        onChange={(e) => handleChange('lugarNacimiento', e.value)}
                        optionValue="configuracionDetId"
                        optionLabel="nombre"
                        filter
                    />

                    <Button
                        icon="pi pi-plus"
                        className="p-button-success"
                        onClick={() => handleAddConfig('PAISES')} // <--- Mismo tipo de config
                        type="button"
                    />
                </div>
            </div>

            {/* CAMPO ESTATURA */}
            <div className="field col-12 md:col-3">
                <label>Estatura</label>
                <div className="p-inputgroup">
                    <InputNumber
                        value={formData.estatura}
                        onValueChange={(e) => handleChange('estatura', e.value)}
                        minFractionDigits={unidadMedida === 'm' ? 2 : 0}
                        maxFractionDigits={unidadMedida === 'm' ? 2 : 0}
                        placeholder={unidadMedida === 'm' ? '1.70' : '170'}
                        className={validationErrors.estatura ? 'p-invalid' : ''}
                    />
                    <Dropdown
                        value={unidadMedida}
                        options={HEIGHT_UNITS}
                        onChange={(e) => handleUnitChange(e.value)}
                        style={{ maxWidth: '100px' }}
                    />
                </div>
                {validationErrors.estatura && (
                    <small className="p-error">{validationErrors.estatura}</small>
                )}
            </div>

            <div className="field col-12 md:col-3">
                <label>Tipo Sangre</label>
                <div className="p-inputgroup">
                    <Dropdown
                        value={formData.tipoSangre}
                        options={listas.tiposSangre} // <--- USA LA LISTA REAL
                        onChange={(e) => handleChange('tipoSangre', e.value)}
                        optionLabel="nombre"
                        optionValue="configuracionDetId"
                    />

                    <Button
                        icon="pi pi-plus"
                        className="p-button-success"
                        onClick={() => handleAddConfig('TIPO_SANGRE')}
                        type="button" // Importante para no enviar el formulario
                    />
                </div>
            </div>
            <div className="field col-12 md:col-3">
                <label>Estado Civil</label>
                <div className="p-inputgroup">
                    <Dropdown
                        value={formData.estadoCivil}
                        options={listas.estadosCiviles} // <--- USA LA LISTA REAL
                        onChange={(e) => handleChange('estadoCivil', e.value)}
                        optionLabel="nombre"
                        optionValue="configuracionDetId"
                    />
                    <Button
                        icon="pi pi-plus"
                        className="p-button-success"
                        onClick={() => handleAddConfig('ESTADO_CIVIL')}
                        type="button"
                    />
                </div>
            </div>

            <div className="field col-12 md:col-5">
                <label>Correo Electronico</label>
                <InputText
                    value={formData.email}
                    onChange={(e) => handleChange('email', e.target.value)}
                    className={validationErrors.email ? 'p-invalid' : ''}
                />
                {validationErrors.email && (
                    <small className="p-error">{validationErrors.email}</small>
                )}
            </div>

            {/* FECHA NACIMIENTO  */}
            <div className="field col-12 md:col-3">
                <label>Fecha de Nacimiento:</label>
                <Calendar value={formData?.fechaNacimientoEmp} showIcon dateFormat="dd/mm/yy"
                onChange={(e) => handleChange('fechaNacimientoEmp', e.value)} />
            </div>

            <div className="field col-12 md:col-3">
                <label>Estado Empleado</label>
                <div className="p-inputgroup">
                    <Dropdown
                        value={formData.estado}
                        options={listas.tiposEstadoEmpleado}
                        onChange={(e) => handleChange('estado', e.value)}
                        optionLabel="nombre"
                        optionValue="configuracionDetId"
                    />
                    <Button
                        icon="pi pi-plus"
                        className="p-button-success"
                        onClick={() => handleAddConfig('ESTADO_CIVIL')}
                        type="button"
                    />
                </div>
            </div>
            {/* ESPACIO */}
            <div className="field col-12 md:col-3">
                <label style={{ visibility: 'hidden' }}>Texto oculto</label>
            </div>
            <div className="field col-12 md:col-3">
                <label style={{ visibility: 'hidden' }}>Texto oculto</label>
            </div>
            {/* CODIGO UNICO */}
            <div className="field col-12 md:col-3">
                <label>Codigo Unico:</label>
                <div className="p-inputgroup">
                    <InputText
                        id="codigoUnico"
                        value={formData?.codigoUnico ? formData?.codigoUnico : ''}
                        type={codigoVisible ? 'text' : 'password'}
                        readOnly
                        placeholder="Sin Código Asignado"
                    />
                    <Button
                        type="button"
                        icon={codigoVisible ? 'pi pi-eye-slash' : 'pi pi-eye'}
                        onClick={toggleVisibility}
                        className="p-button-secondary"
                    />
                </div>
            </div>
            <div className="field col-12 md:col-3 flex align-items-end">
                <Button label="Resetear/Enviar Codigo Unico" onClick={confirmaReset} icon="pi pi-envelope"/>
            </div>
            </>)}

            {puedeVer('BLOQUE_CONTRATACION') && (<>
            {/* SECCIÓN 3: CONTRATACIÓN Y LEGAL */}
            <div className="col-12">
                <Divider align="left">
                    <div className="inline-flex align-items-center">
                        <i className="pi pi-briefcase mr-2"></i>
                        <b>Datos de Contratación</b>
                    </div>
                </Divider>
            </div>
            <div className="field col-12 md:col-3">
                <label>Inicio Contrato</label>
                <Calendar
                    value={formData.fechaIngreso}
                    onChange={(e) => handleChange('fechaIngreso', e.value)}
                    showIcon
                    dateFormat="dd/mm/yy"
                />
            </div>
            <div className="field col-12 md:col-3">
                <label>Fin Contrato</label>
                <Calendar
                    value={formData.fechaFin}
                    onChange={(e) => handleChange('fechaFin', e.value)}
                    showIcon
                    dateFormat="dd/mm/yy"
                />
            </div>

            {!isEditMode && (
                <div className="col-12">
                    <Divider align="center"></Divider>
                    {areModulesDisabled && (
                        <small className="block text-center text-red-500 font-bold mb-2">
                            Guarde el empleado para habilitar los módulos.
                        </small>
                    )}
                </div>
            )}

            {/* CAMPO PENSIÓN ALIMENTICIA */}
            <div className="field col-12 md:col-6 flex flex-column justify-content-end">
                <label>Pensión Alimenticia</label>

                {/* Lógica Visual Dinámica */}
                {!tienePensionDoc || !formData.pensionDocId ? (
                    // ESTADO 1: SIN DOCUMENTO (Mostrar botón de carga)
                    <div className="flex align-items-center h-3rem">
                        <FileUpload
                            ref={fileUploadRef}
                            mode="basic"
                            accept="application/pdf,image/*"
                            chooseLabel={tienePensionDoc ? 'Reemplazar' : 'Adjuntar'}
                            className={`p-button-sm ${
                                tienePensionDoc ? 'p-button-warning' : 'p-button-primary'
                            }`}
                            // 1. MODO AUTOMÁTICO PERO PERSONALIZADO
                            name="file"
                            auto={true} // Sube apenas seleccionas
                            customUpload={true} // ¡IMPORTANTE! Evita que PrimeReact intente subirlo a una URL por defecto
                            // 2. AQUÍ CONECTAMOS TU LÓGICA
                            uploadHandler={async (e) => {
                                // e.files[0] tiene el archivo real
                                await savePensionDoc(e.files[0]);

                                // 3. LIMPIEZA VISUAL DEL BOTÓN
                                if (fileUploadRef.current) {
                                    fileUploadRef.current.clear();
                                }
                            }}
                            disabled={areModulesDisabled}
                        />
                    </div>
                ) : (
                    // ESTADO 2: CON DOCUMENTO (Mostrar Input Readonly + Botones de Acción)
                    <div className="p-inputgroup w-full">
                        <span className="p-inputgroup-addon bg-green-100 text-green-700">
                            <i className="pi pi-check-circle"></i>
                        </span>
                        <InputText
                            value="Documento Cargado"
                            readOnly
                            className="font-bold text-green-700 bg-green-50"
                        />

                        {/* --- BOTÓN VISUALIZAR --- */}
                        <Button
                            icon="pi pi-eye"
                            className="p-button-info" // Azul para ver
                            onClick={handleVerPension}
                            tooltip="Visualizar Documento"
                            tooltipOptions={{ position: 'top' }}
                        />

                        {/* Botón 2: DESCARGAR */}
                        <Button
                            icon="pi pi-download"
                            className="p-button-help" // Color violeta para diferenciar
                            onClick={handleDescargarPension}
                            tooltip="Descargar PDF/Imagen"
                            tooltipOptions={{ position: 'top' }}
                        />

                        {/* Botón 3: BORRAR */}
                        <Button
                            icon="pi pi-trash"
                            className="p-button-danger"
                            onClick={deletePensionDoc}
                            tooltip="Eliminar y Reemplazar"
                            tooltipOptions={{ position: 'top' }}
                        />
                    </div>
                )}
            </div>
            </>)}

            {puedeVer('BLOQUE_LICENCIAS') && (<>
            <div className="col-12 mt-5 mb-2">
                <Divider align="center">
                    <span className="p-tag p-tag-rounded p-tag-info px-4 py-2 shadow-2 text-base uppercase">
                        <i className="pi pi-id-card mr-2"></i>
                        Licencias de Conducir
                    </span>
                </Divider>
            </div>

            <div className="col-12  mb-5">
                <Card
                    header={headerTable('Licencias de Conducir', 'pi pi-id-card', openNewLicencia)}
                >
                    <DataTable
                        value={licenciasFil}
                        {...tableProps}
                        loading={licenciaLoading}
                        size="small"
                        showGridlines
                        filters={filtrosLicencia}
                        filterDisplay="row"
                        emptyMessage="No hay licencias registradas."
                    >
                        {/* 1. CATEGORÍA (Muestra Nombre) */}
                        <Column
                            header="Categoría"
                            field="categoria"
                            filter
                            filterPlaceholder="Buscar por Categoria"
                            filterElement={(options) =>
                                textoFilterTemplateLicencia(options, 'categoria')
                            }
                            showFilterMenu={false}
                            style={{ width: '20%' }}
                        />

                        {/* 2. NÚMERO */}
                        <Column
                            field="numero"
                            header="Número"
                            filter
                            filterPlaceholder="Buscar por Numero"
                            filterElement={(options) =>
                                textoFilterTemplateLicencia(options, 'numero')
                            }
                            showFilterMenu={false}
                        />

                        {/* 3. FECHAS (Formateadas) */}
                        <Column
                            field="fechaEmision"
                            header="Emisión"
                            body={(r) =>
                                r.fechaEmision ? new Date(r.fechaEmision).toLocaleDateString() : ''
                            }
                        />

                        <Column
                            field="fechaVencimiento"
                            header="Vencimiento"
                            body={(r) =>
                                r.fechaVencimiento
                                    ? new Date(r.fechaVencimiento).toLocaleDateString()
                                    : ''
                            }
                        />

                        <Column
                            header="Archivo"
                            body={verArchivosTemplate}
                            style={{ width: '80px', textAlign: 'center' }}
                        />

                        {/* 5. ACCIONES (EDITAR /BORRAR) */}
                        <Column
                            header="Acciones"
                            body={(r) => (
                                <div className="flex gap-2 justify-content-center">
                                    <Button
                                        icon="pi pi-pencil"
                                        className="p-button-rounded p-button-text p-button-warning"
                                        onClick={() => {
                                            openEditLicencia(r);
                                        }}
                                    />
                                    <Button
                                        icon="pi pi-trash"
                                        className="p-button-rounded p-button-text p-button-danger"
                                        onClick={() => anulaLicencia(r)}
                                    />
                                </div>
                            )}
                            style={{ width: '80px', textAlign: 'center' }}
                        />
                    </DataTable>
                </Card>
            </div>
            </>)}

            {/* --- SECCIÓN: LIBRETA MILITAR --- */}
            {puedeVer('BLOQUE_LIBRETAS') && (<>
            <div className="col-12 mt-4 mb-2">
                <Divider align="center">
                    <span className="p-tag p-tag-rounded p-tag-info px-4 py-2 shadow-2 text-base uppercase">
                        <i className="pi pi-book mr-2"></i>
                        Libreta Militar
                    </span>
                </Divider>
            </div>
            <div className="col-12 mb-5">
                <Card header={headerTable('Libreta Militar', 'pi pi-book', openNewLibreta)}>
                    <DataTable
                        value={libretasFil}
                        {...tableProps}
                        size="small"
                        showGridlines
                        filters={filtrosLibreta}
                        filterDisplay="row"
                        emptyMessage="No hay libretas registradas."
                    >
                        {/* 1. TIPO (Muestra el nombre de la categoría en lugar del ID) */}
                        <Column
                            header="Tipo"
                            field="categoria"
                            filter
                            filterPlaceholder="Buscar por categoria"
                            filterElement={(options) =>
                                textoFilterTemplateLibreta(options, 'categoria')
                            }
                            showFilterMenu={false}
                            style={{ width: '20%' }}
                        />

                        {/* 2. NÚMERO */}
                        <Column
                            field="numero"
                            header="Número"
                            filter
                            filterPlaceholder="Buscar por numero"
                            filterElement={(options) =>
                                textoFilterTemplateLibreta(options, 'numero')
                            }
                            showFilterMenu={false}
                        />

                        {/* 3. FECHAS (Formateadas) */}
                        <Column
                            field="fechaIngreso"
                            header="Desde"
                            body={(r) =>
                                r.fechaIngreso ? new Date(r.fechaIngreso).toLocaleDateString() : ''
                            }
                        />

                        <Column
                            field="fechaFin"
                            header="Hasta"
                            body={(r) =>
                                r.fechaFin ? new Date(r.fechaFin).toLocaleDateString() : ''
                            }
                        />

                        {/* 4. ARCHIVO (Botón Ver - Reutilizando archivoBodyTemplate) */}
                        <Column
                            header="Archivo"
                            body={verArchivosTemplate}
                            style={{ width: '80px', textAlign: 'center' }}
                        />

                        {/* 5. ACCIONES (Eliminar) */}
                        <Column
                            header="Acciones"
                            body={(r) => (
                                <div className="flex gap-2 justify-content-center">
                                    <Button
                                        icon="pi pi-pencil"
                                        className="p-button-rounded p-button-text p-button-warning"
                                        onClick={() => openEditLibreta(r)}
                                        tooltip="Editar Libreta"
                                    />
                                    <Button
                                        icon="pi pi-trash"
                                        className="p-button-rounded p-button-text p-button-danger"
                                        onClick={() => anulaLibreta(r)}
                                    />
                                </div>
                            )}
                            style={{ width: '80px', textAlign: 'center' }}
                        />
                    </DataTable>
                </Card>
            </div>
            </>)}

            {/* --- SECCIÓN: Ubicaciones GPS --- */}
            {puedeVer('BLOQUE_GPS') && (<>
            <div className="col-12 mt-4 mb-2">
                <Divider align="center">
                    <span className="p-tag p-tag-rounded p-tag-info px-4 py-2 shadow-2 text-base uppercase">
                        <i className="pi pi-map-marker mr-2"></i>
                        Ubicaciones GPS
                    </span>
                </Divider>
            </div>
            <div className="col-12 mb-5">
                <Card
                    header={headerTable(
                        'Ubicaciones GPS / Mapa',
                        'pi pi-map-marker',
                        openNewUbicacion
                    )}
                >
                    <DataTable
                        value={ubicacionesList}
                        {...tableProps}
                        loading={ubicacionLoading}
                        filters={filtrosUbicacion}
                        filterDisplay="row"
                        emptyMessage="Sin ubicaciones."
                    >
                        <Column
                            field="nombre"
                            header="Nombre"
                            filter
                            filterPlaceholder="Buscar por Nombre"
                            filterElement={(options) =>
                                textoFilterTemplateUbicacion(options, 'nombre')
                            }
                            showFilterMenu={false}
                            style={{ width: '20%' }}
                        />
                        <Column
                            field="descripcion"
                            header="Descripción"
                            filter
                            filterPlaceholder="Buscar por Descripcion"
                            filterElement={(options) =>
                                textoFilterTemplateUbicacion(options, 'descripcion')
                            }
                            showFilterMenu={false}
                            style={{ width: '30%' }}
                        />
                        <Column field="ubicacionGps" header="GPS" style={{ width: '25%' }} />
                        <Column
                            header="Principal"
                            body={(r) => (
                                <div
                                    className="flex justify-content-center align-items-center"
                                    style={{ minHeight: '24px' }}
                                >
                                    {/* Si este ID es el que se está guardando, mostramos el spinner */}
                                    {updatingPrincipalId === r.id ? (
                                        <i
                                            className="pi pi-spin pi-spinner text-primary"
                                            style={{ fontSize: '1.2rem' }}
                                        ></i>
                                    ) : (
                                        <RadioButton
                                            checked={r.esPrincipal}
                                            onChange={() => handleSetPrincipalUbicacion(r)}
                                            // Deshabilitamos si hay CUALQUIER carga para evitar clics dobles
                                            disabled={ubicacionLoading}
                                        />
                                    )}
                                </div>
                            )}
                            className="text-center"
                            style={{ width: '10%' }}
                        />
                        <Column
                            header="Acciones"
                            body={(r) => (
                                <div className="flex gap-2 justify-content-center">
                                    <Button
                                        icon="pi pi-pencil"
                                        className="p-button-text p-button-warning"
                                        onClick={() => openEditUbicacion(r)}
                                    />
                                    <Button
                                        icon="pi pi-trash"
                                        className="p-button-text p-button-danger"
                                        onClick={() => deleteUbicacion(r)}
                                    />
                                </div>
                            )}
                            style={{ width: '15%' }}
                        />
                    </DataTable>
                </Card>
            </div>
            </>)}

            {/* 2. SECCIÓN: TELÉFONOS (TABLA COMPACTA) */}
            {puedeVer('BLOQUE_TELEFONOS') && (<>
            <div className="col-12 mt-4 mb-2">
                <Divider align="center">
                    <span className="p-tag p-tag-rounded p-tag-info px-4 py-2 shadow-2 text-base uppercase">
                        <i className="pi pi-phone mr-2"></i>
                        TELÉFONOS
                    </span>
                </Divider>
            </div>

            <div className="col-12 mb-5">
                <Card header={headerTable('Teléfonos de Contacto', 'pi pi-phone', openNewPhone)}>
                    <DataTable
                        value={phonesFil}
                        {...tableProps}
                        size="small"
                        showGridlines
                        filters={filtrosPhones}
                        filterDisplay="row"
                        emptyMessage="No hay registros"
                    >
                        {/* Usamos el template 'tipoTelefonoTemplate' que ya tienes definido arriba */}
                        <Column
                            header="Tipo"
                            field="tipo"
                            style={{ width: '20%' }}
                            filter
                            filterPlaceholder="Buscar por Tipo"
                            filterElement={(options) => textoFilterTemplatePhones(options, 'tipo')}
                            showFilterMenu={false}
                        />
                        <Column
                            field="numero"
                            header="Número"
                            filter
                            filterPlaceholder="Buscar por Numero"
                            filterElement={(options) =>
                                textoFilterTemplatePhones(options, 'numero')
                            }
                            showFilterMenu={false}
                        />
                        <Column
                            field="referencia"
                            filter
                            filterPlaceholder="Buscar por Referencia"
                            filterElement={(options) =>
                                textoFilterTemplatePhones(options, 'referencia')
                            }
                            showFilterMenu={false}
                            header="Referencia"
                        />
                        <Column
                            header="Principal"
                            body={principalPhoneTemplate}
                            style={{ width: '10%' }}
                            className="text-center"
                        />

                        <Column
                            header="Acciones"
                            body={(r) => (
                                <div className="flex gap-2 justify-content-center">
                                    <Button
                                        icon="pi pi-pencil"
                                        className="p-button-rounded p-button-text p-button-warning"
                                        onClick={() => openEditPhone(r)}
                                    />
                                    <Button
                                        icon="pi pi-trash"
                                        className="p-button-rounded p-button-text p-button-danger"
                                        onClick={() => deletePhone(r)}
                                    />
                                </div>
                            )}
                            style={{ width: '100px', textAlign: 'center' }}
                        />
                    </DataTable>
                </Card>
            </div>
            </>)}
            {/* SECCIÓN 5: EDUCACION */}
            {puedeVer('BLOQUE_EDUCACION') && (<>
            <div className="col-12 mt-4 mb-2">
                <Divider align="center">
                    <span className="p-tag p-tag-rounded p-tag-info px-4 py-2 shadow-2 text-base uppercase">
                        <i className="pi pi-briefcase mr-2"></i>
                        EDUCACION
                    </span>
                </Divider>
            </div>
            <div className="col-12 mb-5">
                <Card header={headerTable(' Educación', 'pi pi-briefcase', openNewEducacion)}>
                    <DataTable
                        value={educacionListFil}
                        {...tableProps}
                        size="small"
                        showGridlines
                        filters={filtrosEducacion}
                        filterDisplay="row"
                        emptyMessage="No hay registros educativos."
                    >
                        <Column
                            header="Nivel"
                            field="categoria"
                            filter
                            filterPlaceholder="Buscar por Categoria"
                            filterElement={(options) =>
                                textoFilterTemplateEducacion(options, 'categoria')
                            }
                            showFilterMenu={false}
                        />

                        <Column
                            field="institucion"
                            header="Institución"
                            filter
                            filterPlaceholder="Buscar por Institucion"
                            filterElement={(options) =>
                                textoFilterTemplateEducacion(options, 'institucion')
                            }
                            showFilterMenu={false}
                        />

                        <Column
                            field="titulo_nombre"
                            header="Título"
                            filter
                            filterPlaceholder="Buscar por Titulo"
                            filterElement={(options) =>
                                textoFilterTemplateEducacion(options, 'titulo_nombre')
                            }
                            showFilterMenu={false}
                        />
                        <Column
                            header="Inicio"
                            body={(r) =>
                                r.fechaInicio ? new Date(r.fechaInicio).toLocaleDateString() : ''
                            }
                        />
                        <Column
                            header="Fin"
                            body={(r) =>
                                r.fechaFin ? new Date(r.fechaFin).toLocaleDateString() : ''
                            }
                        />

                        <Column
                            header="Archivo"
                            body={verArchivosTemplate}
                            style={{ width: '80px', textAlign: 'center' }}
                        />

                        <Column
                            header="Acciones"
                            body={(r) => (
                                <div className="flex gap-2 justify-content-center">
                                    <Button
                                        icon="pi pi-pencil"
                                        className="p-button-rounded p-button-text p-button-warning"
                                        onClick={() => openEditEducacion(r)}
                                        tooltip="Editar Educación"
                                    />
                                    <Button
                                        icon="pi pi-trash"
                                        className="p-button-rounded p-button-text p-button-danger"
                                        onClick={() => anulaEducacion(r)}
                                    />
                                </div>
                            )}
                            style={{ width: '70px', textAlign: 'center' }}
                        />
                    </DataTable>
                </Card>
            </div>
            </>)}

            {/* 6. CUENTAS BANCARIAS */}
            {puedeVer('BLOQUE_CUENTAS') && (<>
            <div className="col-12 mt-4 mb-2">
                <Divider align="center">
                    <span className="p-tag p-tag-rounded p-tag-info px-4 py-2 shadow-2 text-base uppercase">
                        <i className="pi pi-wallet mr-2"></i>
                        CUENTAS BANCARIAS
                    </span>
                </Divider>
            </div>
            <div className="col-12 mb-5">
                <Card header={headerTable('Cuentas Bancarias', 'pi pi-wallet', openNewAccount)}>
                    <DataTable
                        value={accountsFil}
                        {...tableProps}
                        emptyMessage="No hay cuentas registradas."
                        filters={filtrosBancos}
                        filterDisplay="row"
                    >
                        <Column
                            field="numeroCuenta"
                            header="Número"
                            filter
                            filterPlaceholder="Buscar por Numero"
                            filterElement={(options) =>
                                textoFilterTemplateBancos(options, 'numeroCuenta')
                            }
                            showFilterMenu={false}
                        />
                        <Column
                            header="Banco"
                            field="banco"
                            filter
                            filterPlaceholder="Buscar por Banco"
                            filterElement={(options) => textoFilterTemplateBancos(options, 'banco')}
                            showFilterMenu={false}
                        />
                        <Column
                            header="Tipo"
                            field="tipoCuenta"
                            filter
                            filterPlaceholder="Buscar por Tipo"
                            filterElement={(options) =>
                                textoFilterTemplateBancos(options, 'tipoCuenta')
                            }
                            showFilterMenu={false}
                        />
                        <Column
                            header="Principal"
                            body={(r) => (
                                <div className="flex justify-content-center">
                                    <RadioButton
                                        checked={r.esPrincipal}
                                        onChange={() => handleSetPrincipalAccount(r)}
                                        name="radioCuentaPrincipal"
                                    />
                                </div>
                            )}
                            style={{ width: '10%' }}
                            className="text-center"
                        />
                        <Column
                            header="Acciones"
                            body={(r) => (
                                <div className="flex gap-2 justify-content-center">
                                    <Button
                                        icon="pi pi-pencil"
                                        className="p-button-rounded p-button-text p-button-warning"
                                        onClick={() => openEditAccount(r)}
                                    />
                                    <Button
                                        icon="pi pi-trash"
                                        className="p-button-rounded p-button-text p-button-danger"
                                        onClick={() => deleteAccount(r)}
                                    />
                                </div>
                            )}
                            style={{ width: '100px' }}
                        />
                    </DataTable>
                </Card>
            </div>
            </>)}

            {/* 7. HISTORIAL */}
            {puedeVer('BLOQUE_MEMOS') && (<>
            <div className="col-12 mt-4 mb-2">
                <Divider align="center">
                    <span className="p-tag p-tag-rounded p-tag-info px-4 py-2 shadow-2 text-base uppercase">
                        <i className="pi pi-history mr-2"></i>
                        HISTORIAL
                    </span>
                </Divider>
            </div>
            <div className="col-12  mb-4">
                <Card header={headerTable('Historial', 'pi pi-history', openNewHistorial)}>
                    <DataTable
                        value={historialListFil}
                        {...tableProps}
                        emptyMessage="Sin historial."
                        filters={filtrosHistorial}
                        filterDisplay="row"
                    >
                        <Column
                            header="Tipo"
                            field="tipo"
                            filter
                            filterPlaceholder="Buscar por Tipo"
                            filterElement={(options) =>
                                textoFilterTemplateHistorial(options, 'tipo')
                            }
                            showFilterMenu={false}
                        />
                        <Column
                            field="numero"
                            header="Ref/Memo"
                            filter
                            filterPlaceholder="Buscar por Numero"
                            filterElement={(options) =>
                                textoFilterTemplateHistorial(options, 'numero')
                            }
                            showFilterMenu={false}
                        />
                        <Column
                            field="observaciones"
                            header="Observaciones"
                            filter
                            filterPlaceholder="Buscar por Observaciones"
                            filterElement={(options) =>
                                textoFilterTemplateHistorial(options, 'observaciones')
                            }
                            showFilterMenu={false}
                        />

                        <Column
                            header="Fecha Emisión"
                            body={(r) =>
                                r.fechaEmision ? new Date(r.fechaEmision).toLocaleDateString() : ''
                            }
                            style={{ width: '150px' }}
                        />
                        <Column
                            header="Fecha inicio"
                            body={(r) =>
                                r.fecha_inicio ? new Date(r.fecha_inicio).toLocaleDateString() : ''
                            }
                        />

                        <Column
                            header="Fecha fin"
                            body={(r) =>
                                r.fecha_fin ? new Date(r.fecha_fin).toLocaleDateString() : ''
                            }
                        />
                        <Column
                            header="Archivo"
                            body={verArchivosTemplate}
                            style={{ width: '80px', textAlign: 'center' }}
                        />
                        <Column
                            header="Acciones"
                            body={(r) => (
                                <div className="flex gap-2 justify-content-center">
                                    <Button
                                        icon="pi pi-pencil"
                                        className="p-button-rounded p-button-text p-button-warning"
                                        onClick={() => openEditHistorial(r)}
                                    />
                                    <Button
                                        icon="pi pi-trash"
                                        className="p-button-rounded p-button-text p-button-danger"
                                        onClick={() => anulaHistorial(r)}
                                    />
                                </div>
                            )}
                            style={{ width: '90px' }}
                        />
                    </DataTable>
                </Card>
            </div>
            </>)}

            {/* 8. FAMILIA (CARGA FAMILIAR) */}
            {puedeVer('BLOQUE_FAMILIARES') && (<>
            <div className="col-12 mt-4 mb-2">
                <Divider align="center">
                    <span className="p-tag p-tag-rounded p-tag-info px-4 py-2 shadow-2 text-base uppercase">
                        <i className="pi pi-users mr-2"></i> FAMILIA
                    </span>
                </Divider>
            </div>
            <div className="col-12 mb-5">
                <Card header={headerTable('Información Familiar', 'pi pi-users', openNewFamiliar)}>
                    <DataTable
                        value={familiaresFil}
                        {...tableProps}
                        filters={filtrosFamilia}
                        filterDisplay="row"
                        emptyMessage="No hay familiares registrados."
                    >
                        <Column
                            field="nombre"
                            header="Nombre"
                            filter
                            filterPlaceholder="Buscar por Nombre"
                            filterElement={(options) =>
                                textoFilterTemplateFamilia(options, 'nombre')
                            }
                            showFilterMenu={false}
                            style={{ width: '25%' }}
                        />

                        <Column
                            field="fechaNacimiento"
                            header="F. Nacimiento"
                            body={(r) =>
                                r.fechaNacimiento
                                    ? new Date(r.fechaNacimiento).toLocaleDateString()
                                    : ''
                            }
                            style={{ width: '150px' }}
                        />
                        {/* grupo familiar */}
                        <Column
                            header="Grupo"
                            field="tipoFamiliar"
                            filter
                            filterPlaceholder="Buscar por Grupo"
                            filterElement={(options) =>
                                textoFilterTemplateFamilia(options, 'tipoFamiliar')
                            }
                            showFilterMenu={false}
                            style={{ width: '15%' }}
                        />

                        {/* Lookup de  con == para evitar errores de tipo */}
                        <Column
                            field="parentesco"
                            header="Parentesco"
                            filter
                            filterPlaceholder="Buscar por Parentesco"
                            filterElement={(options) =>
                                textoFilterTemplateFamilia(options, 'parentesco')
                            }
                            showFilterMenu={false}
                            style={{ width: '20%' }}
                        />

                        {/* NUEVA COLUMNA: ¿ES CARGA? */}
                        <Column
                            header="¿Es Carga?"
                            body={(r) => (
                                <div className="text-center">
                                    {r.esCargaFamiliar ? (
                                        <span className="p-tag p-tag-success font-bold px-3">
                                            SÍ
                                        </span>
                                    ) : (
                                        <span className="p-tag p-tag-secondary opacity-60 px-3">
                                            NO
                                        </span>
                                    )}
                                </div>
                            )}
                            style={{ width: '110px' }}
                        />
                        <Column
                            header="¿Aplica Utilidad?"
                            body={(r) => (
                                <div className="text-center">
                                    {r.aplicaUtilidad ? (
                                        <span className="p-tag p-tag-success font-bold px-3">
                                            SÍ
                                        </span>
                                    ) : (
                                        <span className="p-tag p-tag-secondary opacity-60 px-3">
                                            NO
                                        </span>
                                    )}
                                </div>
                            )}
                            style={{ width: '110px' }}
                        />
                        <Column
                            field="identificador"
                            header="Nro. Doc"
                            filter
                            filterPlaceholder="Buscar por Nro. Doc"
                            filterElement={(options) =>
                                textoFilterTemplateFamilia(options, 'identificador')
                            }
                            showFilterMenu={false}
                            style={{ width: '20%' }}
                        />

                        <Column
                            header="Acciones"
                            body={(r) => (
                                <div className="flex gap-2 justify-content-center">
                                    <Button
                                        icon="pi pi-pencil"
                                        className="p-button-rounded p-button-text p-button-warning"
                                        onClick={() => openEditFamiliar(r)}
                                    />
                                    <Button
                                        icon="pi pi-trash"
                                        className="p-button-rounded p-button-text p-button-danger"
                                        onClick={() => deleteFamiliar(r)}
                                    />
                                </div>
                            )}
                            style={{ width: '90px' }}
                        />
                    </DataTable>
                </Card>
            </div>
            </>)}

            {/* 9. OTROS DOCUMENTOS */}
            {puedeVer('BLOQUE_DOCUMENTOS') && (<>
            <div className="col-12 mt-4 mb-2">
                <Divider align="center">
                    <span className="p-tag p-tag-rounded p-tag-info px-4 py-2 shadow-2 text-base uppercase">
                        <i className="pi pi-file mr-2"></i>
                        OTROS DOCUMENTOS
                    </span>
                </Divider>
            </div>
            <div className="col-12  mb-5">
                <Card header={headerTable('Otros Documentos', 'pi pi-file', openNewOtrosDocs)}>
                    <DataTable
                        value={otrosDocsListFil}
                        {...tableProps}
                        filters={filtrosOtrosDocs}
                        filterDisplay="row"
                        emptyMessage="No hay documentos adicionales."
                    >
                        <Column
                            header="Categoría"
                            field="categoria_id"
                            filter
                            filterPlaceholder="Buscar por Categoria"
                            filterElement={(options) =>
                                textoFilterTemplateOtrosDocs(options, 'categoria_id')
                            }
                            showFilterMenu={false}
                        />
                        <Column
                            field="numero"
                            header="Número"
                            filter
                            filterPlaceholder="Buscar por Numero"
                            filterElement={(options) =>
                                textoFilterTemplateOtrosDocs(options, 'numero')
                            }
                            showFilterMenu={false}
                        />
                        {/*fecha creacion */}
                        <Column
                            header="Emisión"
                            body={(r) =>
                                r.fecha_inicio ? r.fecha_inicio.toLocaleDateString() : 'N/A'
                            }
                        />
                        <Column
                            header="Vence"
                            body={(r) => (r.fecha_fin ? r.fecha_fin.toLocaleDateString() : 'N/A')}
                        />

                        {/*descripcion */}
                        <Column
                            field="descripcion"
                            header="Descripción"
                            filter
                            filterPlaceholder="Buscar por Descripcion"
                            filterElement={(options) =>
                                textoFilterTemplateOtrosDocs(options, 'descripcion')
                            }
                            showFilterMenu={false}
                        />

                        <Column
                            header="Archivo"
                            body={verArchivosTemplate}
                            style={{ width: '80px', textAlign: 'center' }}
                        />

                        <Column
                            header="Acciones"
                            body={(r) => (
                                <div className="flex gap-2 justify-content-center">
                                    <Button
                                        icon="pi pi-pencil"
                                        className="p-button-rounded p-button-text p-button-warning"
                                        onClick={() => openEditOtrosDocs(r)}
                                    />
                                    <Button
                                        icon="pi pi-trash"
                                        className="p-button-rounded p-button-text p-button-danger"
                                        onClick={() => anulaOtrosDocs(r)}
                                    />
                                </div>
                            )}
                            style={{ width: '90px' }}
                        />
                    </DataTable>
                </Card>
            </div>
            </>)}

            {/* 10. FOTOS (GALERÍA) */}
            {puedeVer('BLOQUE_FOTOS') && (<>
            <div className="col-12 mt-4 mb-2">
                <Divider align="center">
                    <span className="p-tag p-tag-rounded p-tag-info px-4 py-2 shadow-2 text-base uppercase">
                        <i className="pi pi-images mr-2"></i>
                        FOTOS
                    </span>
                </Divider>
            </div>

            <div className="col-12 mb-5">
                <Card header={headerTable('Galería de Fotos', 'pi pi-images', openNewFoto)}>
                    <DataTable
                        value={fotosList}
                        {...tableProps}
                        filters={filtrosFotos}
                        filterDisplay="row"
                        emptyMessage="No hay fotos en la galería."
                    >
                        <Column
                            header="Miniatura"
                            body={(r) => <FotoThumbnail id={r.id} descripcion={r.descripcion} />}
                            style={{ width: '80px', textAlign: 'center' }}
                        />
                        <Column
                            field="descripcion"
                            header="Descripción / Título"
                            filter
                            filterPlaceholder="Buscar por Titulo"
                            filterElement={(options) =>
                                textoFilterTemplateFotos(options, 'descripcion')
                            }
                            showFilterMenu={false}
                        />

                        <Column
                            header="Fecha"
                            body={(r) => (r.fecha ? new Date(r.fecha).toLocaleDateString() : '')}
                            style={{ width: '120px' }}
                        />

                        <Column
                            header="Acciones"
                            body={(r) => (
                                <div className="flex gap-2 justify-content-center">
                                    <Button
                                        icon="pi pi-eye"
                                        className="p-button-rounded p-button-text p-button-info"
                                        tooltip="Ver Foto"
                                        onClick={() => handleVerDocumento(r)}
                                    />

                                    <Button
                                        icon="pi pi-trash"
                                        className="p-button-rounded p-button-text p-button-danger"
                                        onClick={() => deleteFoto(r)}
                                    />
                                </div>
                            )}
                            style={{ width: '100px' }}
                        />
                    </DataTable>
                </Card>
            </div>
            </>)}

            {/* Sección Experiencia Laboral en FormularioPrincipal.js */}
            {puedeVer('BLOQUE_EXPERIENCIA') && (<>
            <div className="col-12 mt-4 mb-2">
                <Divider align="center">
                    <span className="p-tag p-tag-rounded p-tag-info px-4 py-2 shadow-2 text-base uppercase">
                        <i className="pi pi-briefcase mr-2"></i> EXPERIENCIA LABORAL
                    </span>
                </Divider>
            </div>
            <div className="col-12 mb-5">
                <Card
                    header={headerTable(
                        'Experiencia Laboral',
                        'pi pi-briefcase',
                        openNewExperiencia
                    )}
                >
                    <DataTable
                        value={experiencias}
                        {...tableProps}
                        filters={filtrosExperiencia}
                        filterDisplay="row"
                        loading={experienciaLoading}
                        emptyMessage="No hay registros."
                    >
                        <Column
                            field="empresa"
                            header="Empresa"
                            filter
                            filterPlaceholder="Buscar por Empresa"
                            filterElement={(options) =>
                                textoFilterTemplateExperiencia(options, 'empresa')
                            }
                            showFilterMenu={false}
                            style={{ width: '25%' }}
                        />
                        <Column
                            field="proyecto"
                            header="Proyecto"
                            filter
                            filterPlaceholder="Buscar por Proyecto"
                            filterElement={(options) =>
                                textoFilterTemplateExperiencia(options, 'proyecto')
                            }
                            showFilterMenu={false}
                        />
                        <Column
                            header="Ingreso"
                            body={(r) => r.fechaIngreso?.toLocaleDateString()}
                        />
                        <Column header="Salida" body={(r) => r.fechaSalida?.toLocaleDateString()} />
                        <Column header='Tiempo Exp.' field='tiempoExperiencia' />
                        <Column
                            field="motivoSalida"
                            header="Motivo Salida"
                            filter
                            filterPlaceholder="Buscar por Motivo"
                            filterElement={(options) =>
                                textoFilterTemplateExperiencia(options, 'motivoSalida')
                            }
                            showFilterMenu={false}
                        />
                        <Column
                            header="Acciones"
                            body={(r) => (
                                <div className="flex gap-2 justify-content-center">
                                    <Button
                                        icon="pi pi-pencil"
                                        className="p-button-rounded p-button-text p-button-warning"
                                        onClick={() => openEditExperiencia(r)}
                                    />
                                    <Button
                                        icon="pi pi-trash"
                                        className="p-button-rounded p-button-text p-button-danger"
                                        onClick={() => deleteExperiencia(r)}
                                    />
                                </div>
                            )}
                            style={{ width: '100px' }}
                        />
                    </DataTable>
                </Card>
            </div>
            </>)}

            {/* Sección Dotaciones */}
            {puedeVer('BLOQUE_DOTACIONES') && (<>
            <div className="col-12 mt-4 mb-2">
                <Divider align="center">
                    <span className="p-tag p-tag-rounded p-tag-info px-4 py-2 shadow-2 text-base uppercase">
                        <i className="pi pi-briefcase mr-2"></i> DOTACIONES
                    </span>
                </Divider>
            </div>
            <div className="col-12 mb-5">
                <DotacionesLista empleadoId={formData.id} />
            </div>
            </>)}

            {/* FIN Sección Dotaciones */}

            <Dialog
                header="Visualización de Pensión"
                visible={visorVisible}
                style={{ width: '50vw', minWidth: '350px' }}
                modal
                onHide={() => setVisorVisible(false)}
                maximizable
                dismissableMask
                contentStyle={{ padding: '0', textAlign: 'center', backgroundColor: '#333' }}
            >
                {visorContent && (
                    <div
                        className="flex justify-content-center align-items-center"
                        style={{ minHeight: '400px' }}
                    >
                        <img
                            src={visorContent}
                            alt="Documento Pensión"
                            style={{ maxWidth: '100%', maxHeight: '80vh', objectFit: 'contain' }}
                        />
                    </div>
                )}
            </Dialog>

            {/* PARA VER LAS FOTOS SEGUN CABECERA  */}
            <Dialog
                header="Ver Archivos"
                style={{ width: '50vw', minWidth: '350px' }}
                visible={mostrarArchivos}
                onHide={() => setMostrarArchivos(false)}
            >
                <VerArchivosGen datosCabecera={cabeceraData} />
            </Dialog>
        </div>
    );
}
